import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader = ({ loading }) => {
  if (!loading) return null; // Render nothing if loading is false

  return (
    <Box sx={styles.container}>
      <CircularProgress size={60} sx={{ color: 'rgba(35, 64, 0, 1)' }} />
    </Box>
  );
};

const styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.7)',
    zIndex: 1,
  },
};

export default Loader;
